
export const BLOCKCHAIN_BINANCE = +process.env.VUE_APP_BINANCE_CHAIN_ID

export const NATIVE_CURRENCY_BY_BLOCKCHAIN = {
  [BLOCKCHAIN_BINANCE]: 'BNB'
}

export const NAME_BY_BLOCKCHAIN = {
  [BLOCKCHAIN_BINANCE]: 'Binance Smart Chain'
}

export const PROVIDER_BY_CHAIN_ID = {
  [BLOCKCHAIN_BINANCE]: process.env.VUE_APP_WEB3_PROVIDER_BINANCE
}

export const EXPLORER_BY_BLOCKCHAIN = {
  [BLOCKCHAIN_BINANCE]: process.env.VUE_APP_EXPLORER_BINANCE
}

export const WEB3_PROVIDER_METAMASK = 'metamask'
